// src/utils/printComponent.js
import ReactDOMServer from 'react-dom/server';

export const printComponent = (componentToPrint) => {
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
        alert("Por favor, permite las ventanas emergentes para imprimir.");
        return;
    }

    // 1. Convertimos el componente React a un string de HTML
    const componentHtml = ReactDOMServer.renderToString(componentToPrint);

    // 2. Extraemos los estilos de Material-UI
    // Esta es una técnica para obtener los estilos generados por MUI.
    const muiStyles = Array.from(document.head.querySelectorAll('style[data-mui-style]'))
        .map(style => style.outerHTML)
        .join('');

    // 3. Construimos el documento HTML completo
    const fullHtml = `
        <html>
            <head>
                <title>Imprimir</title>
                ${muiStyles}
                <style>
                    @media print {
                        @page {
                            size: 57mm 30mm;
                            margin: 0;
                        }
                        body {
                            margin: 0 !important;
                            padding: 0 !important;
                        }
                    }
                </style>
            </head>
            <body>
                ${componentHtml}
            </body>
        </html>
    `;

    // 4. Escribimos el HTML en la nueva ventana
    printWindow.document.open();
    printWindow.document.write(fullHtml);
    printWindow.document.close();

    // 5. Esperamos a que todo cargue y luego imprimimos
    printWindow.onload = () => {
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500); // Aumentamos el tiempo a 500ms para más seguridad
    };
};